import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function ProtectedRoute({ children }) {
  const { auth } = useAuth();

  if (!auth.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  if (!auth.is2FA) {
    return <Navigate to="/2fa" />;
  }

  return children;
}
